module.exports = __webpack_public_path__ + "ee9575d5167a6ffb3381cf3be523d29a.svg";